import { takeEvery } from "redux-saga/effects";
import api from "../../../utils/apiService";
import { ENDPOINT } from "../../../config/endpoints";
import { getSaleSummaryReportApi } from "../../slices/SaleSummarySlice";

/**
 * Uplifted from `redux-store/saga/saleSummary` (apps/web + apps/mobile).
 *
 * The two apps' bodies are IDENTICAL in logic — the whole diff is quote style, brace placement
 * and a trailing comma — so `shared.ts` owns it and both platform files re-export.
 *
 * ⚠️ Bare folder imports are REQUIRED in a `shared.ts` (hazard 16) — see `licenceExpirySaga`.
 *
 * ⚠️ `commonPostData` swallows its error and returns `undefined`, so a failed request reaches
 * `data.callback(undefined)` rather than the catch below. Preserved verbatim — it is what the
 * one caller (`apps/web/src/components/SaleSummary`) branches on.
 *
 * 🔴 **The catch's `.data.` typo IS fixed (2026-09-08), together with guarding the callback.**
 * It read `actions.payload.data.callback(...)` where the try reads `data.callback(...)` on
 * `actions.payload` itself — a key this payload has never had, so the error path threw instead
 * of reporting, and `takeEvery` would have carried that throw to the root and cancelled the
 * watcher. Nothing reaches it today: `commonPostData` swallows, and the only caller passes a
 * callback. It was fixed anyway because `saga/loyalty` had the identical pair and the second
 * half only became reachable when a new caller made the callback optional — see that file's
 * header for what it cost. Behaviour is unchanged on every path that used to run.
 *
 * Dropped under standing rule 2(b): both apps imported `put` from `redux-saga/effects` and
 * NEITHER referenced it (measured 0 uses on both sides). Nothing else changes.
 */
async function commonPostData(data: any) {
  try {
    const postApi = api.request(data);
    const fetchResponse = await postApi;
    return fetchResponse;
  } catch (e) {}
}

function* fetchSummaryData(actions: any): Generator<any, void, any> {
  let url = ENDPOINT.SALESUMMARY.getsaleSummary();
  try {
    let data = actions.payload;
    let dataToSend = {
      url: url,
      method: "POST",
      data: JSON.stringify(data.postBody),
    };
    let response = yield commonPostData(dataToSend);
    data.callback?.(response);
  } catch (e) {
    console.log("check data ", e);
    actions.payload?.callback?.({
      code: "Something went wrong. Please try again later",
      status: false,
    });
  }
}

export default function* root() {
  yield takeEvery(getSaleSummaryReportApi.type, fetchSummaryData);
}
